import React from "react";
import image from "../assets/profile/no-data.jpg";

const NoDataFound = () => {
  return (
    <div className="d-flex justify-content-center align-items-center my-4">
      <img
        src={image}
        alt="no data found"
        className="no-data-img"
      />
    </div>
  );
};

export default NoDataFound;
